import ListGroup from '../List/ListGroup';
import ListItem from '../List/ListItem';

export default {
  Group: ListGroup,
  Item: ListItem,
};
